import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AssessmentFieldConfig } from './AssessmentFieldConfig';
import type { AssessmentConfigFormData, ValidationErrors } from '../types';

type Props = {
  formData: AssessmentConfigFormData;
  validationErrors: ValidationErrors;
  onUpdateField: <K extends keyof AssessmentConfigFormData>(
    field: K,
    value: AssessmentConfigFormData[K]
  ) => void;
};

export const AssessmentConfigContent = ({
  formData,
  validationErrors,
  onUpdateField
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        maxWidth: 1200,
        margin: '0 auto',
        p: { xs: 2, sm: 3, md: 4 }
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <AssessmentFieldConfig
            title={t('settings:equipmentAssessment.condition.title')}
            valuesLabel={t(
              'settings:equipmentAssessment.condition.valuesLabel'
            )}
            valuesPlaceholder={t(
              'settings:equipmentAssessment.condition.valuesPlaceholder'
            )}
            valuesHelper={t(
              'settings:equipmentAssessment.condition.valuesHelper'
            )}
            requiredLabel={t(
              'settings:equipmentAssessment.condition.requiredLabel'
            )}
            values={formData.conditionValues}
            required={formData.conditionRequired}
            errorKey={validationErrors.conditionValues}
            onValuesChange={value => onUpdateField('conditionValues', value)}
            onRequiredChange={value =>
              onUpdateField('conditionRequired', value)
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <AssessmentFieldConfig
            title={t('settings:equipmentAssessment.operability.title')}
            valuesLabel={t(
              'settings:equipmentAssessment.operability.valuesLabel'
            )}
            valuesPlaceholder={t(
              'settings:equipmentAssessment.operability.valuesPlaceholder'
            )}
            valuesHelper={t(
              'settings:equipmentAssessment.operability.valuesHelper'
            )}
            requiredLabel={t(
              'settings:equipmentAssessment.operability.requiredLabel'
            )}
            values={formData.operabilityValues}
            required={formData.operabilityRequired}
            errorKey={validationErrors.operabilityValues}
            onValuesChange={value => onUpdateField('operabilityValues', value)}
            onRequiredChange={value =>
              onUpdateField('operabilityRequired', value)
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};
